import script from "./ProductCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCard.vue?vue&type=script&setup=true&lang=ts"

import "./ProductCard.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__